module.exports = __webpack_public_path__ + "src/assets/img/door_left.bb528f7b.svg";